
import { useEffect, useMemo } from 'react'
import { useField } from 'formik'
import PropTypes from 'prop-types'
import { useIcdCodes, useFetchIcdCodes } from '../../redux/slices/icd-codes'
import Select from './Select'

export default function IcdCodesSelect({ mode = undefined, ...props }) {
  const [field] = useField(props)
  const { value = [] } = field
  const icdCodes = useIcdCodes()
  const fetchIcdCodes = useFetchIcdCodes()

  useEffect(() => {
    if (icdCodes.length === 0) {
      fetchIcdCodes()
    }
  }, [icdCodes, fetchIcdCodes])

  const getOption = code => ({
    value: code.id,
    label: `${code.code} - ${code.description}`,
  })

  const options = useMemo(() => icdCodes.map(getOption), [icdCodes])
  const isMultiple = mode === 'multiple'
  const values = useMemo(() => {
    if (!isMultiple) {
      return value != null ? value : undefined
    }
    return typeof value === 'string' ? [String(value)] : (value || []).map(val => Number(val))
  }, [value, isMultiple])

  return <Select
    options={options}
    filterOption
    showSearch
    allowClear
    wrapperItem
    optionFilterProp="label"
    placeholder="Select ICD Codes"
    valuePropName="value"
    labelPropName="label"
    dropdownWidth={300}
    labelCol={{ md: { span: 2 } }}
    wrapperCol={{ md: { span: 18 } }}
    {...props}
    mode={mode}
    value={values}
  />
}

IcdCodesSelect.propTypes = {
  mode: PropTypes.oneOf(['multiple', 'tags']),
}
